import { Button } from "@mui/material";
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { utils, write } from "xlsx";
import server from "../../server";
import DashboardContext from "../Context/DashboardContext";
import useStore from "../stores.ts";
import TrolleyModal from "./Layout/TrolleyModal";
import TrolleyTable from "./Layout/TrolleyTable";

const XLSX = { utils, write };

async function fetchAndSaveAsXlsx(apiUrl, fileName, params = {}) {
  try {
    // Make the API call
    const response = await axios.get(apiUrl, {
      params,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    });

    // Check if the response data is an array
    const apiResponse = response.data;
    if (!Array.isArray(apiResponse) || apiResponse.length === 0) {
      throw new Error(
        "Invalid API response: must be a non-empty array of objects.",
      );
    }

    // Create a new workbook
    const workbook = XLSX.utils.book_new();
    // Convert the API response to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(apiResponse);
    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    // Generate a Blob from the workbook
    const fileBlob = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    // Create a Blob object
    const blob = new Blob([fileBlob], { type: "application/octet-stream" });

    // Create a link element
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    // Append to the body
    document.body.appendChild(link);
    // Trigger the download
    link.click();

    // Clean up and remove the link
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);

    console.log(`Data saved to ${fileName}`);
  } catch (error) {
    console.error("Error fetching data or saving to XLSX:", error.message);
  }
}
const Trolley = () => {
  const context = useContext(DashboardContext);
  const navigate = useNavigate();

  const { setLoading } = context;
  const [trolleys, setTrolleys] = useState([]);
  const [open, setOpen] = useState(false);

  const {
    dateRange: { from, to },
  } = useStore();

  const [trolleyInformation, setTrolleyInformation] = useState({
    qrCode: "",
    isEngaged: false,
    physicalWeight: "0",
    virtualCartWeight: "0",
  });

  const createTrolley = async () => {
    try {
      const result = await axios.post(
        `${server}/trolley/create`,
        {
          trolleyInformation,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        },
      );

      setTrolleys((prevTrolleys) => [...prevTrolleys, result.data]);
      setTrolleyInformation("");
      toast.success("Trolley created successfully!");
    } catch (error) {
      // Check if the error response exists and has data
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        // Show the error message in a toast
        toast.error(error.response.data.message);
      } else {
        // Handle other errors (like network issues)
        toast.error("Something went wrong. Please try again.");
      }

      console.log(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Trolley Information is ", trolleyInformation);
    await createTrolley();
    setTrolleyInformation("");
    handleClose();
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setTrolleyInformation("");
    setOpen(false);
  };

  const getAllTrolleys = async () => {
    try {
      const result = await axios.get(`${server}/trolleys`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      setTrolleys(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("adminuser")) navigate("/");
    else {
      setLoading(true);
      getAllTrolleys();
      setLoading(false);
    }
  }, []);

  return (
    <div>
      <div className="order-head">
        <p className="order-title">Trolley Summary</p>
      </div>
      <div className="flex justify-between">
        <button
          className="bg-blue-600 text-white p-3 rounded-md"
          onClick={() =>
            fetchAndSaveAsXlsx(
              "https://urbanbazaarpune.in/api/v1/products/synclogs",
              `product_sync_logs_${new Date().toLocaleDateString()}`,
              { from, to },
            )
              .then(() => console.log("product_sync_logs successfully"))
              .catch((err) => console.log("product_sync_logs failed", err))
          }
        >
          Export Sync Log
        </button>

        <Button
          variant="outlined"
          color="primary"
          sx={{
            marginBottom: "10px",
            marginRight: "10px",
          }}
          onClick={(e) => {
            e.preventDefault();
            handleOpen();
          }}
        >
          Create
        </Button>
      </div>

      <TrolleyModal
        open={open}
        handleClose={handleClose}
        handleSubmit={handleSubmit}
        trolleyInformation={trolleyInformation}
        setTrolleyInformation={setTrolleyInformation}
      />
      <div>
        <TrolleyTable
          rows={trolleys}
          setRows={setTrolleys}
          trolleys={trolleys}
        />
      </div>
    </div>
  );
};

export default Trolley;
